import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { check_permission } from "../Service/ApiServices";
import { toast } from "react-toastify";

const initialState = {
  checkpermission: {
    add: false,
    update: false,
    delete: false,
    show: false,
  },
  perloading: false,
  error: null,
};

export const checkPermission = createAsyncThunk(
  "checkpermission/checkPermission",
  async ({ data, token,school_id, signal }, { rejectWithValue }) => {
    try {
      const response = await check_permission(data, token,school_id, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const checkpermissionSlice = createSlice({
  name: "checkpermissions",
  initialState,
  reducers: {
    resetPermissions: (state) => {
      state.checkpermission = {
        add: false,
        update: false,
        delete: false,
        show: false,
      }; // Resetting to initial state
      state.error = null; // Resetting error
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkPermission.pending, (state) => {
        state.perloading = true;
        state.error = null; // Reset error on new request
      })
      .addCase(checkPermission.fulfilled, (state, action) => {
        state.perloading = false;
        state.checkpermission = action.payload; // Update permissions
      })
      .addCase(checkPermission.rejected, (state, action) => {
        state.perloading = false;
        state.error = action.payload; // Store error message
      });
  },
});

export const { resetPermissions } = checkpermissionSlice.actions;
export default checkpermissionSlice.reducer;
